<template>
  <pt-sheet title="Trigger Runnables">
    <v-form ref="form">
      <v-row>
        <v-col cols="5">
          <v-select
            v-model="runnable"
            :items="runnables"
            placeholder="Select a runnable method to run..."
          >
          </v-select>
        </v-col>
      </v-row>
      <v-btn @click="run" color="primary">
        Run
      </v-btn>
    </v-form>
  </pt-sheet>
</template>

<script>
import PtSheet from "@/components/PtSheet.vue";
import { get, post } from "@/services/request";
import { qaRunnablesAPI } from "@/services/api";
import hasNotifications from "@/mixins/has-notifications";

export default {
  name: "QARunnables",
  mixins: [hasNotifications],
  components: { PtSheet },
  data: () => ({
    runnables: [],
    runnable: null
  }),
  created() {
    this.loadRunnables();
  },
  methods: {
    loadRunnables() {
      get(qaRunnablesAPI)
        .then(response => {
          if (response && response.data) {
            this.runnables = response.data || [];
          }
        })
        .catch(() => {
          this.showMessage({
            text: "Unable to load runnables",
            mode: "error"
          });
          return Promise.reject();
        });
    },
    run() {
      if (!this.runnable) {
        return;
      }
      let request = {
        runnable: this.runnable
      };
      post(qaRunnablesAPI, request).then(
        () => {
          let successMessage = `Runnable ${request.runnable} was triggered`;
          this.showMessage(successMessage);
        },
        err => {
          console.error(err);
          this.showMessage({
            mode: "error",
            text: "Failed to run runnable"
          });
        }
      );
    }
  }
};
</script>

<style scoped lang="scss"></style>
